// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tWzy","label":"styles_label__3x053"};